import script from "./ScriptEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptEditor.vue?vue&type=script&setup=true&lang=js"

import "./ScriptEditor.vue?vue&type=style&index=0&id=50a3ca26&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a3ca26"]])

export default __exports__